<button mat-icon-button class="corner_action_button square" (click)="eeClick.emit()" [attr.aria-label]="ariaLabel" [ngClass]="{adjust_more: adjustMoreToTheCorner}">
	<mat-icon class="color_black_inactive">{{icon}}</mat-icon>
</button>